import api, { fetchAllPages } from "./client";

export const metodosPagoApi = {
  getAll: (params = {}) => fetchAllPages("/metodos-pago/", params),
  create: (data) => api.post("/metodos-pago/", data),
  update: (id, data) => api.patch(`/metodos-pago/${id}/`, data),
};
